import React from "react";
import { Box, Button, Heading } from "grommet";
import { HeaderNavigation } from "../components/Headers/GlobalHeader";
import { StickyFooter } from "../components/Footers/GlobalFooter";
import { useNavigate, useParams } from "react-router-dom";
import UserAssessmentDetails from "../components/Dashboard/UserAssessmentsDetails";
import { LinkPrevious } from "grommet-icons";
const AssessmentHistory = () => {
  const { user_id } = useParams();
  const navigate = useNavigate();

  const handleRetake = () => {
    navigate(`/add-proficiency/${user_id}`);
  };

  return (
    <Box fill="vertical" justify="between">
      <Box flex="grow">
        <HeaderNavigation />
        <Box pad="medium" direction="row" justify="between" align="begin">
          <LinkPrevious
            onClick={() => navigate(-1)}
            color="brand"
            pad="small"
          />

          <Button label="Take new assessment" primary onClick={handleRetake} />
        </Box>
        <Box pad="medium" direction="column" justify="between" align="center">
          <Heading level="1">Assessment history</Heading>
          <UserAssessmentDetails user_id={user_id} />
        </Box>
      </Box>
      <StickyFooter />
    </Box>
  );
};

export default AssessmentHistory;
